module.exports = __webpack_public_path__ + "img/ic_close_light_grey.08274126.svg";